import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import ReferalModel from "models/referal.modal";
import { toast } from "lib/helper";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import Loader from "components/loader/Loader";
import callbackrequestModel from "models/callbackrequest.model";

const Callbackrequest = () => {
  const [Status, setStatus] = useState("Approved");
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const [indicate, setIndicate] = useState("All");

  const getListData = async () => {
    setIsLoading(true);

    await callbackrequestModel.get()
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setDataList(result?.data);
          
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  

  useEffect(() => {
    getListData();
   
  }, []);

 

  const getListDataAccordingcondition = async (status) => {
    console.log("check status", status);
    setIsLoading(true);
    if (status == "All") {
      await ReferalModel.List()
        .then((result) => {
          setIsLoading(false);
          if (result) {
            setDataList(result?.data);
          
            setIndicate(status);
            setCurrentPage(result?.meta?.current_page);
            setPerPage(result?.meta?.per_page);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else {
      await ReferalModel.Listbystate(status)
        .then((result) => {
          setIsLoading(false);
          if (result) {
            setDataList(result?.data);
          
            setIndicate(status);
            setCurrentPage(result?.meta?.current_page);
            setPerPage(result?.meta?.per_page);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete request", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
            callbackrequestModel.Delete(delId).then((res) => {
            helper.sweetalert.toast("deleted sucessfully","success");
            getListData();
          });
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  const [item, setItem] = useState();

  const GetDetail = async (item) => {
    setItem(item?.id);
  };

  const Mark = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
   
    callbackrequestModel.Mark(item, form)
      .then((responce) => {
        toggle();
        toast("Marked sucessfully", "success");
        getListData();
        
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const [searchTerm, setSearchTerm] = useState("");
  console.log("dddeeerr",dataList)
  const filteredDataList = dataList?.filter((item) => {
    const fullName =
      `${item.auth_user.first_name} ${item.auth_user.last_name}`.toLowerCase();
    
    const status = item.status.toLowerCase();
    const search = searchTerm.toLowerCase();

    return (
      fullName.includes(search) ||
      
      status.includes(search)
    );
  });
  return (
    <div className="pt-7 px-4 overflow-x-hidden">
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between ">
              <h3 className="mb-0">All Callback Request </h3>

              <div className="d-flex flex-row">
                {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                <Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </CardHeader>
          
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S. No.</th>
                  
                  <th scope="col">Name / Mobile no.</th>
                 
                  <th scope="col">Status</th>
                 
                  <th scope="col">Action</th>
                
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center align-middle w-full"
                    >
                      Please wait...
                      <Loader />
                    </td>
                  </tr>
                ) : filteredDataList?.length > 0 ? (
                  filteredDataList?.length > 0 ? (
                    filteredDataList.map((item, index) => {
                      console.log("dta", item);
                      return (
                        <tr key={item._id} style={{ cursor: "pointer" }}>
                          <td>{(currentPage - 1) * perPage + index + 1}</td>
                          <td>
                            <div>
                              <div>
                                {item?.auth_user?.first_name || "-"}{" "}
                                {item?.auth_user?.last_name}
                              </div>
                              <div style={{color:"blue"}}>
                                <span style={{color:"gray"}}>mob.no - </span>
                                {item?.auth_user?.username}
                              </div>
                            </div>
                          </td>
                          
                          <td>{item?.status || "-"}</td>
                        
                          <td
                            className="p-0"
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            
                              
                                <UncontrolledTooltip
                                  placement="top"
                                  target={`Markpaid${index}`}
                                >
                                  Update
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "23px",
                                    borderRadius: "30%",
                                  }}
                                  id={`Markpaid${index}`}
                                  onClick={() => {
                                    toggle();
                                    GetDetail(item);
                                  }}
                                >
                                  <i className="fa-solid fa-check"></i>
                                </Link>
                                <UncontrolledTooltip
                                placement="top"
                                target="deleteTooltip"
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "red",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "23px",
                                    borderRadius: "30%",
                                }}
                                id="deleteTooltip"
                                onClick={() => handleDel(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                        
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="14"
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          height: "100px",
                        }}
                      >
                        No data found
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ textAlign: "center", padding: "1rem" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Mark To/Declined/Approved</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={Mark}>
           
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Approved / Declined</Label>
                  <Input
                    id="forType"
                    type="select"
                    name="status"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="Approved">Approved</option>
                    <option value="Declined">Declined</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
           
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Callbackrequest;
